export const RECAPTCHA_SITE_KEY = `6LeQQzoaAAAAAOcCzYnsgcNDT3y_r8lKzvON4PEJ`